// @module C3.ShoppingExtensions.System8Page
define('C3.ShoppingExtensions.System8Page.View'
,	[
	    'c3_shoppingextensions_system8page.tpl'
	,	'SCView'
	,   'GlobalViews.Breadcrumb.View'
	,   'Utils'

    ]
, function (
	    c3_shoppingextensions_system8page_tpl
	,	SCViewModule
	,   GlobalViewsBreadcrumbView
	,   Utils
)
{
    'use strict';

     var SCView = SCViewModule.SCView;

     function System8PageView (options) {
     	SCView.call(this, options);

     	this.template = c3_shoppingextensions_system8page_tpl;
        this.options = options;
		this.category = options.category;
		this.application = options.application;
     }

     System8PageView.prototype = Object.create(SCView.prototype);
     System8PageView.prototype.constructor = System8PageView;

     System8PageView.prototype.getChildViews = function (){
     	return {
     		'System8.Breadcrumb': function(){
       	    	const breadcrumb = [];

       	    	 breadcrumb[0] = {
		                href : '/',
		                'data-hashtag' : '#',
		                'data-touchpoint': "home",
		                hasDataHashtag: true,
		                hasDataTouchpoint: true,
		                text: "Home"
		          }

	            const list = this.category.breadcrumb;
	            const self = this;

	            _.each(list, function(bread) {
	                breadcrumb.push({
	                    text: bread.name,
	                    href: bread.fullurl
	                });
	            });
	            //console.log(breadcrumb)
                return new GlobalViewsBreadcrumbView({
	        			 pages: breadcrumb 
	        		});
       	    }
     	}
     }

     System8PageView.prototype.render = function () {
    	SCView.prototype.render.call(this);
    	
    }

    System8PageView.prototype.getContext = function () {
    	return {
    			name: this.category.name,
	            // @property {String} banner
	            banner: this.category.pagebannerurl,
	            // @property {String} description
	            description: this.category.description,
	            // @property {String} pageheading
	            pageheading: this.category.pageheading || this.category.name,
	            // @property {Boolean} hasBanner
	            hasBanner: !!this.category.pagebannerurl,
	            isPhone : Utils.isPhoneDevice(),
				isTablet : Utils.isTabletDevice()
    	}
    }

     return System8PageView;
});
